// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"570c5e22","977":"2434d61a"}[chunkId] + ".chunk.js";
};